module.exports = __webpack_public_path__ + "static/media/F-2.1681077c.webp";